/* eslint-disable @typescript-eslint/no-explicit-any */
import Image from '../../Image';
import { ReactElement } from 'react';
import { IAttribute, Ibreadcrumb } from '../../interfaces';
import Breadcrumb from '../sections/Breadcrumb';

interface LayoutType {
    children: ReactElement;
    attribute?: IAttribute;
    title?: string | string[];
    subTitle?: string;
    origin?: string;
    breads?: Ibreadcrumb[];
    activeIcon?: boolean;
}

export default function LayoutInside({
    children,
    attribute,
    title,
    subTitle,
    origin,
    breads,
    activeIcon = true,
}: LayoutType): JSX.Element {
    return (
        <>
            {breads && breads.length > 0 && <Breadcrumb contents={breads} color={attribute?.color.bg} />}
            <div
                className={`${attribute?.color.bg}   ${
                    origin !== 'slider' ? 'pt-24 md:pt-28 md:pb-5 min-h-layout ' : ' pt-5 md:pb-5'
                }`}
            >
                {/** Header Attribute */}
                <div className={`flex-col ${origin !== 'slider' && 'pt-4'}`}>
                    <div className={`flex justify-center content-center pt`}>
                        {' '}
                        {attribute && activeIcon && (
                            <Image
                                src={attribute.icon.image}
                                alt={attribute.alt}
                                height={attribute.icon.height}
                                width={attribute.icon.width}
                            />
                        )}
                    </div>
                    {(title || attribute?.subTitle) && (
                        <p className="text-center text-xl font-bold italic text-sm-blue-primary pt-4 pb-2">
                            {title || attribute?.subTitle}
                        </p>
                    )}
                </div>
                {subTitle && (
                    <div className={`flex-col`}>
                        <p className="text-center text-base  text-sm-blue-primary pt-1 pb-4">{subTitle}</p>
                    </div>
                )}
                {children}
            </div>
        </>
    );
}
